import styled from 'styled-components';
import { Link } from 'react-router-dom';
import media from '../base/media';
import { ReactComponent as IconFooterImage } from '../../figures/footer-mynd.svg';

export const Footer = styled.footer`
	position: relative;
	padding: 6.5rem;
	transition: transform 250ms, opacity 250ms;
	transition-delay: 250ms;
	max-width: 192rem;
	margin: 0 auto;

	${({ hidden }) => hidden && `
		transform: translate3d(0, 100%, 0);
		opacity: 0;
	`};

	${media.desktopSmall`
		display: flex;
		justify-content: space-between;
		margin-top: 15rem;
	`};

	${media.desktopLarge`
		padding-left: 13.5rem;
		padding-right: 13.5rem;
		padding-bottom: 15rem;
	`};
`;

export const Nav = styled.nav`
	${media.desktopSmall`
		width: 40%;
	`}
`;

export const NavItem = styled.div`

`;

export const LeftWrapper = styled.div`
	display: flex;
`;

export const FooterImage = styled(IconFooterImage)`
	display: none;

	${media.desktopSmall`
		display: flex;
		margin-top: -15rem;
		margin-left: 5rem;
	`}

	${media.desktopLarge`
		margin-left: 12rem;
	`}
`;

export const LogoLink = styled(Link)`
	padding: 2rem;

	${media.desktopSmall`
		display: none;
	`};
`;

export const NavItemLink = styled(Link)`
	color: ${props => props.theme.colors.gray};
	font-size: 1.5rem;
	line-height: 2.5rem;
	transition: color 150ms;

	&:hover {
		color: ${props => props.theme.colors.grayDarker2};
	}
`;

export const SocialMedia = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;

	${media.desktopSmall`
		margin: 0;
	`};
`;

export const LinkWrapper = styled.div`
	display: flex;
`;

export const SocialMediaLink = styled.a`
	padding: 2rem;

	&:first-child {
		padding-left: 0;
	}

	svg g {
		transition: fill 100ms;
	}

	&:hover svg g {
		fill: ${props => props.theme.colors.primary};
	}
`;

export const GraphicsWrapper = styled.div`
	display: block;
	position: absolute;
	left: -37rem;
	bottom: -15rem;
	z-index: -1;
`;

export const DesktopLogoLink = styled(Link)`
	display: none;

	${media.desktopSmall`
		display: flex;
	`};
`;
